export default "__VITE_ASSET__D5EKPrq0__"